import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AnnualBehaviorNote } from '../../types/domain';
import { getAnnualBehaviorNotes, loadAnnualBehaviorNotesCache } from '../../services/annualBehaviorNotesService';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';

export type UseAnnualBehaviorNotesQueryParams = {
  workspaceId: string;
  academicYear: number;
  termNumber: 1 | 2;
  gradeId: string;
  enabled?: boolean;
  forceRefresh?: boolean;
};

export function useAnnualBehaviorNotesQuery(
  params: UseAnnualBehaviorNotesQueryParams
): UseQueryResult<AnnualBehaviorNote[]> {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    enabled = true,
    forceRefresh = false,
  } = params;

  const cached = loadAnnualBehaviorNotesCache(workspaceId, academicYear, termNumber, gradeId);

  return useQuery<AnnualBehaviorNote[]>({
    queryKey: schoolKeys.annualBehaviorNotes(workspaceId, academicYear, termNumber, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(cached != null, cached ?? []),
    queryFn: () =>
      getAnnualBehaviorNotes(workspaceId, academicYear, termNumber, gradeId, { forceRefresh }),
  });
}
